export default __webpack_public_path__ + "static/media/Img1.7b9b0fe2.png";